/** Recorded pre-revision law from b0eaad5: speed 65 gives E19.5, R20.3,
 * heat1.2. Damage kernel is E(1-.7r/R). Its integral over a sphere is
 * 4π E R³ (1/3-.7/4). The trial spreads exactly ten times that budget over
 * a 1.6x radius: peak damage becomes 10/1.6³ = 2.44140625 times baseline.
 * Speed, heat and structural impulse energy retain their baselines. Body mass
 * derives from the new actual geometry, with no independent mass multiplier.
 * Actual damaged-cell counts depend on occupied geometry and are measured.
 */
export function planeImpact(speed: number, upgraded = false) {
  const energy = Math.min(24, Math.max(5, speed * 0.3)),
    radius = Math.min(22, 6 + speed * 0.22),
    radiusScale = upgraded ? 1.6 : 1,
    damageScale = upgraded ? 10 / radiusScale ** 3 : 1;
  return {
    energy,
    radius: radius * radiusScale,
    damageScale,
    heat: 1.2,
    budget: 4 * Math.PI * energy * (radius * radiusScale) ** 3 * (1 / 3 - 0.7 / 4) * damageScale,
  };
}
